import { useContext } from "react";
import CommentForm from "./CommentForm";
import CommentList from "./CommentList";
import { AuthContext } from "../../context/AuthProvider";

const Comment = ({ board, boardItem, parent, className = "" }) => {
  const { isAuthenticated } = useContext(AuthContext);

  return !!board?.options?.useComment ? (
    <div
      className={`flex flex-col md:gap-10 gap-4 pt-10 border-t border-gray-border ${className}`}
    >
      <CommentList board={board} boardItem={boardItem} />
      {(isAuthenticated ||
        (!isAuthenticated && !!board?.options?.useAnonymousInComment)) && (
        <CommentForm board={board} parent={parent} boardItem={boardItem} />
      )}
    </div>
  ) : null;
};

export default Comment;
